var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login",attrs:{"id":"element"}},[_c('div',{staticClass:"login--item "},[_c('Header')],1),_vm._v(" "),_c('div',{staticClass:"section-gray"},[_c('div',{staticClass:"section-white"},[_c('LoginModal',{on:{"loginSuccess":_vm.congratsAfterLogin}})],1)]),_vm._v(" "),_c('div',{staticClass:"login--item"},[_c('Footer')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cdc1d46","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Login/index.vue
// module id = null
// module chunks = 